// Copyright (c) 2016 Deere & Company

import WarrantyMediumModal from './medium-modal';

export default WarrantyMediumModal;
